import axios from 'axios';
import qs from 'qs';
import { SiweMessage } from 'siwe';
import { SIWENS } from '@justaname.id/siwens';
import { createPublicClient, http } from 'viem';
import { mainnet, sepolia } from 'viem/chains';
import { ethers } from 'ethers';

function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

function getBaseUrl(dev = false) {
    // return 'http://localhost:3000';
    if (dev) {
        return 'https://api-staging.justaname.id';
    }
    return 'https://api.justaname.id';
}
/**
 * The instance of axios with the base URL of JustaName API.
 */ const justANameInstance = (dev = false)=>axios.create({
        baseURL: getBaseUrl(dev)
    });
/**
 * Represents the controlled axios promise.
 * @typeparam T - The type of the data to be returned.
 * @param promise
 * @returns The promise of the data.
 */ const controlledAxiosPromise = (promise)=>promise.then((res)=>{
        if (res.data.result.data === null) {
            var _res_data_result_error;
            throw new Error((_res_data_result_error = res.data.result.error) != null ? _res_data_result_error : 'Something went wrong');
        }
        return res.data.result.data;
    }).catch((err)=>{
        if (err == null ? void 0 : err.response) {
            var _err_response_data, _err_response;
            if (err == null ? void 0 : (_err_response = err.response) == null ? void 0 : (_err_response_data = _err_response.data) == null ? void 0 : _err_response_data.result) {
                var _err_response_data_result, _err_response_data1, _err_response1;
                if (err == null ? void 0 : (_err_response1 = err.response) == null ? void 0 : (_err_response_data1 = _err_response1.data) == null ? void 0 : (_err_response_data_result = _err_response_data1.result) == null ? void 0 : _err_response_data_result.error) {
                    throw new Error(err.response.data.result.error);
                }
            }
        }
        throw err;
    });

/**
 * Global prefix for all routes
 */ const GLOBAL_PREFIX = '';

/**
 * Prefix for all Subname routes
 */ // TODO: should be
// export const SUBNAME_BASE_ROUTE = GLOBAL_PREFIX + '/subname';
const SUBNAME_BASE_ROUTE = GLOBAL_PREFIX + '/ens/v1/subname';
/**
 *
 * Routes to accept subname invitation
 */ const ACCEPT_SUBNAME_ROUTE = SUBNAME_BASE_ROUTE + '/accept';
/**
 * Routes to reserve subname
 */ const RESERVE_SUBNAME_ROUTE = SUBNAME_BASE_ROUTE + '/reserve';
/**
 * Routes to add subname
 */ const ADD_SUBNAME_ROUTE = SUBNAME_BASE_ROUTE + '/add';
/**
 * Routes to update subname
 */ const UPDATE_SUBNAME_ROUTE = SUBNAME_BASE_ROUTE + '/update';
/**
 * Routes to revoke subname
 */ const REVOKE_SUBNAME_ROUTE = SUBNAME_BASE_ROUTE + '/revoke';
/**
 * Routes to reject subname
 */ const REJECT_SUBNAME_ROUTE = SUBNAME_BASE_ROUTE + '/reject';
/**
 * Routes to get subname by full subname
 */ const GET_SUBNAME_BY_SUBNAME_ROUTE = SUBNAME_BASE_ROUTE + '/subname';
/**
 * Routes to get all subnames by domain
 */ const GET_ALL_SUBNAMES_BY_DOMAIN_ROUTE = SUBNAME_BASE_ROUTE + '/ens';
/**
 * Routes to get all subnames by address
 */ const GET_ALL_SUBNAMES_BY_ADDRESS_ROUTE = SUBNAME_BASE_ROUTE + '/address';
/**
 * Routes to check subname availability
 */ const CHECK_SUBNAME_AVAILABILITY_ROUTE = SUBNAME_BASE_ROUTE + '/available';
/**
 * Route to search for subnames
 */ const SEARCH_SUBNAMES_ROUTE = SUBNAME_BASE_ROUTE + '/search';
/**
 * Route to get all subnames
 */ const RECORDS_BY_FULLNAME_ROUTE = SUBNAME_BASE_ROUTE + '/records';
const GET_ALL_ENS_WITH_COUNT_ROUTE = SUBNAME_BASE_ROUTE + '/ens-list';

/**
 * Prefix for all SIWE routes
 */ const SIWE_BASE_ROUTE = GLOBAL_PREFIX + '/ens/v1/siwe';
/**
 * Routes for SIWE Request Challenge
 */ const SIWE_REQUEST_CHALLENGE_ROUTE = SIWE_BASE_ROUTE + '/request-challenge';
/**
 * Routes for SIWE Verify Message
 */ const SIWE_VERIFY_MESSAGE_ROUTE = SIWE_BASE_ROUTE + '/verify-message';
/**
 * Routes for SIWE Request Challenge to Add MAPP Permission
 */ const SIWE_MAPP_ADD_PERMISSION_ROUTE = SIWE_BASE_ROUTE + '/mapp/add-permission';
/**
 * Routes for SIWE Request Challenge to Append Field
 */ const SIWE_MAPP_APPEND_FIELD_ROUTE = SIWE_BASE_ROUTE + '/mapp/append-field';
/**
 * Routes for SIWE Request Challenge to Revoke Permission
 */ const SIWE_MAPP_REVOKE_PERMISSION_ROUTE = SIWE_BASE_ROUTE + '/mapp/revoke-permission';

/**
 * Prefix for all MAPP routes
 */ const MAPP_ROUTE = GLOBAL_PREFIX + '/ens/v1/mapp';
/**
 * Routes for MAPP Add Permission
 */ const MAPP_ADD_PERMISSION_ROUTE = MAPP_ROUTE + '/permission/add';
/**
 * Routes for MAPP Append Field
 */ const MAPP_APPEND_FIELD_ROUTE = MAPP_ROUTE + '/field/append';
/**
 * Routes for MAPP Revoke Permission
 */ const MAPP_REVOKE_PERMISSION_ROUTE = MAPP_ROUTE + '/permission/revoke';

/**
 * Prefix for all OFFCHAIN_RESOLVERS routes and to fetch all offchain resolvers
 */ const OFFCHAIN_RESOLVERS_ROUTE = GLOBAL_PREFIX + '/ens/v1/offchain-resolvers';
const GET_ALL_OFFCHAIN_RESOLVERS_ROUTE = OFFCHAIN_RESOLVERS_ROUTE;

/**
 * Prefix for all primary name routes
 **/ const PRIMARY_NAME_BASE_ROUTE = GLOBAL_PREFIX + '/ens/v1/primary-name';
const GET_PRIMARY_NAME_BY_ADDRESS_ROUTE = PRIMARY_NAME_BASE_ROUTE + '/address';
const SET_PRIMARY_NAME_ROUTE = PRIMARY_NAME_BASE_ROUTE + '/set-primary-name';

const Routes = {
    SIWE_VERIFY_MESSAGE_ROUTE,
    SIWE_REQUEST_CHALLENGE_ROUTE,
    SIWE_MAPP_ADD_PERMISSION_ROUTE,
    SIWE_MAPP_APPEND_FIELD_ROUTE,
    SIWE_MAPP_REVOKE_PERMISSION_ROUTE,
    MAPP_ADD_PERMISSION_ROUTE,
    MAPP_APPEND_FIELD_ROUTE,
    MAPP_REVOKE_PERMISSION_ROUTE,
    ACCEPT_SUBNAME_ROUTE,
    RESERVE_SUBNAME_ROUTE,
    ADD_SUBNAME_ROUTE,
    UPDATE_SUBNAME_ROUTE,
    REJECT_SUBNAME_ROUTE,
    REVOKE_SUBNAME_ROUTE,
    GET_SUBNAME_BY_SUBNAME_ROUTE,
    GET_ALL_SUBNAMES_BY_DOMAIN_ROUTE,
    GET_ALL_SUBNAMES_BY_ADDRESS_ROUTE,
    GET_ALL_SUBNAMES_BY_INVITATION_ROUTE: GET_ALL_SUBNAMES_BY_ADDRESS_ROUTE,
    CHECK_SUBNAME_AVAILABILITY_ROUTE,
    SEARCH_SUBNAMES_ROUTE,
    RECORDS_BY_FULLNAME_ROUTE,
    GET_ALL_ENS_WITH_COUNT_ROUTE,
    GET_ALL_OFFCHAIN_RESOLVERS_ROUTE,
    GET_PRIMARY_NAME_BY_ADDRESS_ROUTE,
    SET_PRIMARY_NAME_ROUTE
};

class InvalidENSException extends Error {
    static notRegisteredENS(ENS) {
        const message = `InvalidENSException: ENS ${ENS} is not registered`;
        return new InvalidENSException(message);
    }
    static chainNotSupported(chainId) {
        const message = `InvalidENSException: Chain ${chainId} is not supported`;
        return new InvalidENSException(message);
    }
    constructor(message){
        super(message);
    }
}

class InvalidConfigurationException extends Error {
    static missingParameters(parameters) {
        return new InvalidConfigurationException(`Missing parameters: ${parameters.join(', ')}, please provide them in the configuration or in the function parameters`);
    }
    static missingHeaders(headers) {
        return new InvalidConfigurationException(`Missing headers: ${headers.join(', ')}, please provide them in the configuration or in the function parameters`);
    }
    static missingParameterOrHeader(parameterOrHeader) {
        return new InvalidConfigurationException(`Missing parameter or header: ${parameterOrHeader}, please provide them in the headers or in the function parameters`);
    }
    constructor(message){
        super(message);
        this.name = 'InvalidConfigurationException';
    }
}

class ApiKeyRequiredException extends Error {
    static apiKeyRequired() {
        const message = 'ApiKeyRequiredException: this operation requires an API key';
        return new ApiKeyRequiredException(message);
    }
    constructor(message){
        super(message);
    }
}

class InvalidSignInException extends Error {
    static domainMismatch(domain, signedDomain) {
        const message = `InvalidSignInException: domain mismatch. Expected ${domain} but got ${signedDomain}`;
        return new InvalidSignInException(message);
    }
    static chainIdMismatch(chainId, signedChainId) {
        const message = `InvalidSignInException: chainId mismatch. Expected ${chainId} but got ${signedChainId}`;
        return new InvalidSignInException(message);
    }
    static nonceMismatch(nonce, signedNonce) {
        const message = `InvalidSignInException: nonce mismatch. Expected ${nonce} but got ${signedNonce}`;
        return new InvalidSignInException(message);
    }
    static chainIdNotSupported(chainId) {
        const message = `InvalidSignInException: chainId ${chainId} not supported`;
        return new InvalidSignInException(message);
    }
    constructor(message){
        super(message);
    }
}

const restCall = (route, method, request, headers, dev)=>{
    const currentHeaders = {
        'x-api-key': undefined,
        'x-message': undefined,
        'x-signature': undefined,
        'x-address': undefined
    };
    if (headers) {
        if ('xApiKey' in headers) {
            currentHeaders['x-api-key'] = headers.xApiKey;
        }
        if ('xMessage' in headers) {
            currentHeaders['x-message'] = headers['xMessage'].replace(/\n/g, '\\n');
        }
        if ('xSignature' in headers) {
            currentHeaders['x-signature'] = headers['xSignature'];
        }
        if ('xAddress' in headers) {
            currentHeaders['x-address'] = headers['xAddress'];
        }
    }
    return controlledAxiosPromise(justANameInstance(dev).request({
        url: Routes[route],
        method,
        params: method === 'GET' ? request : undefined,
        paramsSerializer: (params)=>{
            return qs.stringify(params, {
                arrayFormat: 'repeat'
            });
        },
        data: method === 'POST' ? request : undefined,
        headers: currentHeaders
    }));
};
// Function implementation
function assertRestCall(route, method, request, headers, dev) {
    return (requiredFields, requiredHeaders)=>{
        const missingFields = requiredFields.filter((field)=>request[field] === undefined);
        if (missingFields.length) {
            throw InvalidConfigurationException.missingParameters(missingFields.map((field)=>field.toString()));
        }
        if (headers && requiredHeaders) {
            const missingHeaders = requiredHeaders.filter((header)=>headers[header] === undefined);
            if (missingHeaders.length) {
                throw InvalidConfigurationException.missingHeaders(missingHeaders.map((header)=>header.toString()));
            }
        } else if (requiredHeaders && requiredHeaders.length > 0) {
            throw InvalidConfigurationException.missingHeaders(requiredHeaders.map((header)=>header.toString()));
        }
        return restCall(route, method, request, headers, dev);
    };
}

class ChallengeRequestException extends Error {
    static invalidTimeValue() {
        const message = 'ChallengeRequestException: Invalid time value';
        return new ChallengeRequestException(message);
    }
    static invalidOrigin(origin) {
        const message = `ChallengeRequestException: Invalid origin: ${origin}`;
        return new ChallengeRequestException(message);
    }
    static domainRequired() {
        const message = 'ChallengeRequestException: Domain is required';
        return new ChallengeRequestException(message);
    }
    static invalidChainId(chainId) {
        const message = `ChallengeRequestException: Invalid chainId: ${chainId}, only 1 and 11155111 are supported`;
        return new ChallengeRequestException(message);
    }
    static originRequired() {
        const message = 'ChallengeRequestException: Origin is required';
        return new ChallengeRequestException(message);
    }
    static invalidAddress(address) {
        const message = `ChallengeRequestException: Invalid address: ${address}`;
        return new ChallengeRequestException(message);
    }
    static generatingChallengeFailed() {
        const message = 'ChallengeRequestException: Generating challenge failed';
        return new ChallengeRequestException(message);
    }
    constructor(message){
        super(message);
    }
}

class SubnameChallenge {
    /**
   * Sends a request to initiate a challenge.
   *
   * @param {RequestChallengeRequest} params - The request parameters.
   * @returns {Promise<RequestChallengeResponse>} - A promise that resolves with the response.
   * @public
   */ requestChallenge(params) {
        var _this_siweConfig, _this_siweConfig1;
        const { chainId, ttl, origin, domain, address } = params;
        const _ttl = ttl || this.subnameChallengeTtl || 120000;
        const _chainId = chainId || this.chainId;
        const _origin = ((_this_siweConfig = this.siweConfig) == null ? void 0 : _this_siweConfig.origin) || origin;
        const _domain = ((_this_siweConfig1 = this.siweConfig) == null ? void 0 : _this_siweConfig1.domain) || domain;
        const _address = address;
        if (!_origin) {
            throw ChallengeRequestException.originRequired();
        }
        if (!_domain) {
            throw ChallengeRequestException.domainRequired();
        }
        if (_chainId !== 1 && _chainId !== 11155111) {
            throw ChallengeRequestException.invalidChainId(_chainId);
        }
        if (_ttl <= 0 || _ttl + Date.now() >= Number.MAX_SAFE_INTEGER) {
            throw ChallengeRequestException.invalidTimeValue();
        }
        const urlRegex = new RegExp('^(http|https)://', 'i');
        if (!urlRegex.test(_origin)) {
            throw ChallengeRequestException.invalidOrigin(_origin);
        }
        const ethAddressRegex = new RegExp('^0x[a-fA-F0-9]{40}$');
        if (!ethAddressRegex.test(_address)) {
            throw ChallengeRequestException.invalidAddress(_address);
        }
        const statement = `Please sign this message to verify that you want to add/update your subdomain provided by ${_domain} to your account ${_address} using JustAName`;
        const { expirationTime, issuedAt } = this.generateIssuedAndExpirationTime(_ttl);
        const siweMessage = new SiweMessage({
            domain: _domain,
            uri: _origin,
            address: _address,
            statement: statement,
            chainId: _chainId,
            version: '1',
            issuedAt,
            expirationTime
        });
        return {
            challenge: siweMessage.prepareMessage()
        };
    }
    /**
   * Sends a request to verify a specific address using SIWE.
   * @param {VerifyChallengeRequest} params - The request parameters.
   * @returns {Promise<VerifyChallengeResponse>} - A promise that resolves with the response.
   * @public
   */ verifyMessage(params) {
        return assertRestCall('SIWE_VERIFY_MESSAGE_ROUTE', 'POST', params, undefined, this.dev)([
            'address',
            'signature',
            'message'
        ]);
    }
    generateIssuedAndExpirationTime(ttl) {
        const date = new Date();
        const issuedAt = date.toISOString();
        const expirationTime = new Date(date.getTime() + ttl).toISOString();
        return {
            issuedAt,
            expirationTime
        };
    }
    constructor(params){
        this.siweConfig = params.siweConfig;
        this.chainId = params.chainId;
        this.subnameChallengeTtl = params.subnameChallengeTtl;
        this.dev = params.dev;
    }
}

function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var evmCoinTypeToNameMap = Object.freeze({
    /* Chain ID: 10 */ "2147483658": [
        "op",
        "Optimism"
    ],
    /* Chain ID: 25 */ "2147483673": [
        "cro",
        "Cronos"
    ],
    /* Chain ID: 56 */ "2147483704": [
        "bsc",
        "BNB Smart Chain"
    ],
    /* Chain ID: 60 */ "2147483708": [
        "go",
        "GoChain"
    ],
    /* Chain ID: 61 */ "2147483709": [
        "etc",
        "Ethereum Classic"
    ],
    /* Chain ID: 88 */ "2147483736": [
        "tomo",
        "TomoChain"
    ],
    /* Chain ID: 99 */ "2147483747": [
        "poa",
        "POA"
    ],
    /* Chain ID: 100 */ "2147483748": [
        "gno",
        "Gnosis"
    ],
    /* Chain ID: 108 */ "2147483756": [
        "tt",
        "ThunderCore"
    ],
    /* Chain ID: 137 */ "2147483785": [
        "matic",
        "Polygon"
    ],
    /* Chain ID: 169 */ "2147483817": [
        "manta",
        "Manta Pacific"
    ],
    /* Chain ID: 246 */ "2147483894": [
        "ewt",
        "Energy Web"
    ],
    /* Chain ID: 250 */ "2147483898": [
        "ftm",
        "Fantom Opera"
    ],
    /* Chain ID: 288 */ "2147483936": [
        "boba",
        "Boba"
    ],
    /* Chain ID: 324 */ "2147483972": [
        "zksync",
        "zkSync"
    ],
    /* Chain ID: 361 */ "2147484009": [
        "theta",
        "Theta"
    ],
    /* Chain ID: 820 */ "2147484468": [
        "clo",
        "Callisto"
    ],
    /* Chain ID: 1088 */ "2147484736": [
        "metis",
        "Metis"
    ],
    /* Chain ID: 5000 */ "2147488648": [
        "mantle",
        "Mantle"
    ],
    /* Chain ID: 8453 */ "2147492101": [
        "base",
        "Base"
    ],
    /* Chain ID: 39797 */ "2147523445": [
        "nrg",
        "Energi"
    ],
    /* Chain ID: 42161 */ "2147525809": [
        "arb1",
        "Arbitrum One"
    ],
    /* Chain ID: 42220 */ "2147525868": [
        "celo",
        "Celo"
    ],
    /* Chain ID: 43114 */ "2147526762": [
        "avaxc",
        "Avalanche C-Chain"
    ],
    /* Chain ID: 59144 */ "2147542792": [
        "linea",
        "Linea"
    ],
    /* Chain ID: 534352 */ "2148018000": [
        "scr",
        "Scroll"
    ],
    /* Chain ID: 7777777 */ "2155261425": [
        "zora",
        "Zora"
    ]
});
var nonEvmCoinTypeToNameMap = Object.freeze({
    "0": [
        "btc",
        "Bitcoin"
    ],
    "2": [
        "ltc",
        "Litecoin"
    ],
    "3": [
        "doge",
        "Dogecoin"
    ],
    "4": [
        "rdd",
        "Reddcoin"
    ],
    "5": [
        "dash",
        "Dash"
    ],
    "6": [
        "ppc",
        "Peercoin"
    ],
    "7": [
        "nmc",
        "Namecoin"
    ],
    "14": [
        "via",
        "Viacoin"
    ],
    "20": [
        "dgb",
        "DigiByte"
    ],
    "22": [
        "mona",
        "Monacoin"
    ],
    "42": [
        "dcr",
        "Decred"
    ],
    "43": [
        "xem",
        "NEM"
    ],
    "55": [
        "aib",
        "AIB"
    ],
    "57": [
        "sys",
        "Syscoin"
    ],
    "60": [
        "eth",
        "Ethereum"
    ],
    "61": [
        "etcLegacy",
        "[LEGACY] Ethereum Classic"
    ],
    "74": [
        "icx",
        "ICON"
    ],
    "77": [
        "xvg",
        "Verge"
    ],
    "105": [
        "strat",
        "Stratis"
    ],
    "111": [
        "ark",
        "ARK"
    ],
    "118": [
        "atom",
        "Atom"
    ],
    "121": [
        "zen",
        "Zencash"
    ],
    "128": [
        "xmr",
        "Monero"
    ],
    "133": [
        "zec",
        "Zcash"
    ],
    "134": [
        "lsk",
        "Lisk"
    ],
    "135": [
        "steem",
        "Steem"
    ],
    "136": [
        "firo",
        "Firo"
    ],
    "137": [
        "rbtc",
        "RSK"
    ],
    "141": [
        "kmd",
        "Komodo"
    ],
    "144": [
        "xrp",
        "Ripple"
    ],
    "145": [
        "bch",
        "Bitcoin Cash"
    ],
    "148": [
        "xlm",
        "Stellar Lumens"
    ],
    "153": [
        "btm",
        "Bytom"
    ],
    "156": [
        "btg",
        "Bitcoin Gold"
    ],
    "165": [
        "nano",
        "Nano"
    ],
    "175": [
        "rvn",
        "Ravencoin"
    ],
    "178": [
        "poaLegacy",
        "[LEGACY] POA"
    ],
    "192": [
        "lcc",
        "LitecoinCash"
    ],
    "194": [
        "eos",
        "EOS"
    ],
    "195": [
        "trx",
        "Tron"
    ],
    "204": [
        "bcn",
        "Bytecoin"
    ],
    "235": [
        "fio",
        "FIO"
    ],
    "236": [
        "bsv",
        "BitcoinSV"
    ],
    "242": [
        "nim",
        "Nimiq"
    ],
    "246": [
        "ewtLegacy",
        "[LEGACY] Energy Web"
    ],
    "283": [
        "algo",
        "Algorand"
    ],
    "291": [
        "iost",
        "IOST"
    ],
    "301": [
        "divi",
        "Divi Project"
    ],
    "304": [
        "iotx",
        "IoTeX"
    ],
    "308": [
        "bts",
        "Bitshares"
    ],
    "309": [
        "ckb",
        "Nervos CKB"
    ],
    "313": [
        "zil",
        "Zilliqa"
    ],
    "326": [
        "mrx",
        "Metrix Coin"
    ],
    "330": [
        "luna",
        "Terra"
    ],
    "354": [
        "dot",
        "Polkadot"
    ],
    "360": [
        "vsys",
        "V Systems"
    ],
    "367": [
        "abbc",
        "ABBC"
    ],
    "397": [
        "near",
        "NEAR Protocol"
    ],
    "415": [
        "etn",
        "Electroneum"
    ],
    "425": [
        "aion",
        "Aion"
    ],
    "434": [
        "ksm",
        "Kusama"
    ],
    "457": [
        "ae",
        "æternity"
    ],
    "459": [
        "kava",
        "Kava"
    ],
    "461": [
        "fil",
        "Filecoin"
    ],
    "472": [
        "ar",
        "Arweave"
    ],
    "489": [
        "cca",
        "Counos"
    ],
    "500": [
        "thetaLegacy",
        "[LEGACY] Theta"
    ],
    "501": [
        "sol",
        "Solana"
    ],
    "508": [
        "egld",
        "MultiversX"
    ],
    "535": [
        "xhv",
        "Haven Protocol"
    ],
    "539": [
        "flow",
        "Flow"
    ],
    "566": [
        "iris",
        "Irisnet"
    ],
    "568": [
        "lrg",
        "Large Coin"
    ],
    "569": [
        "sero",
        "Super Zero Protocol"
    ],
    "570": [
        "bdx",
        "Beldex"
    ],
    "571": [
        "ccxx",
        "Counos X"
    ],
    "573": [
        "srm",
        "Serum"
    ],
    "574": [
        "vlxLegacy",
        "[LEGACY] Velas"
    ],
    "576": [
        "bps",
        "BitcoinPoS"
    ],
    "589": [
        "tfuel",
        "Theta Fuel"
    ],
    "592": [
        "grin",
        "Grin"
    ],
    "700": [
        "gnoLegacy",
        "[LEGACY] Gnosis"
    ],
    "714": [
        "bnb",
        "BNB"
    ],
    "818": [
        "vet",
        "VeChain"
    ],
    "820": [
        "cloLegacy",
        "[LEGACY] Callisto"
    ],
    "825": [
        "hive",
        "Hive"
    ],
    "888": [
        "neo",
        "NEO"
    ],
    "889": [
        "tomoLegacy",
        "[LEGACY] TomoChain"
    ],
    "904": [
        "hnt",
        "Helium"
    ],
    "931": [
        "rune",
        "THORChain"
    ],
    "999": [
        "bcd",
        "Bitcoin Diamond"
    ],
    "1001": [
        "ttLegacy",
        "[LEGACY] ThunderCore"
    ],
    "1007": [
        "ftmLegacy",
        "[LEGACY] Fantom"
    ],
    "1023": [
        "one",
        "HARMONY-ONE"
    ],
    "1024": [
        "ont",
        "Ontology"
    ],
    "1237": [
        "nostr",
        "Nostr"
    ],
    "1729": [
        "xtz",
        "Tezos"
    ],
    "1815": [
        "ada",
        "Cardano"
    ],
    "1991": [
        "sc",
        "Sia"
    ],
    "2301": [
        "qtum",
        "QTUM"
    ],
    "2303": [
        "gxc",
        "GXChain"
    ],
    "2305": [
        "ela",
        "Elastos"
    ],
    "2718": [
        "nas",
        "Nebulas"
    ],
    "3030": [
        "hbar",
        "Hedera HBAR"
    ],
    "4218": [
        "iota",
        "IOTA"
    ],
    "5353": [
        "hns",
        "Handshake"
    ],
    "5757": [
        "stx",
        "Stacks"
    ],
    "6060": [
        "goLegacy",
        "[LEGACY] GoChain"
    ],
    "8444": [
        "xch",
        "Chia"
    ],
    "8964": [
        "nuls",
        "NULS"
    ],
    "9000": [
        "avax",
        "Avalanche"
    ],
    "9004": [
        "strk",
        "StarkNet"
    ],
    "9797": [
        "nrgLegacy",
        "[LEGACY] Energi"
    ],
    "16754": [
        "ardr",
        "Ardor"
    ],
    "19167": [
        "flux",
        "Flux"
    ],
    "52752": [
        "celoLegacy",
        "[LEGACY] Celo"
    ],
    "99999": [
        "wicc",
        "Waykichain"
    ],
    "5655640": [
        "vlx",
        "Velas"
    ],
    "5718350": [
        "wan",
        "Wanchain"
    ],
    "5741564": [
        "waves",
        "Waves"
    ]
});
var coinTypeToNameMap = Object.freeze(_object_spread({}, nonEvmCoinTypeToNameMap, evmCoinTypeToNameMap));

const coinTypeMap = Object.keys(coinTypeToNameMap).reduce((acc, key)=>{
    const coin = key;
    const symbol = coinTypeToNameMap[coin];
    acc[coin] = {
        coin: symbol[1],
        symbol: symbol[0],
        coinType: coin
    };
    return acc;
}, {});
const getCoinTypeDetails = (cointype)=>{
    const coinTypeDetails = coinTypeMap[cointype];
    if (coinTypeDetails) {
        return _extends({}, coinTypeDetails);
    }
    return {
        coin: 'NON',
        symbol: 'NON',
        coinType: '-1'
    };
};

const GENERAL_FIELDS = [
    {
        name: 'Avatar',
        identifier: 'avatar'
    },
    {
        name: 'Header',
        identifier: 'header'
    },
    {
        name: 'Nickname',
        identifier: 'display'
    },
    {
        name: 'Description',
        identifier: 'description'
    },
    {
        name: 'Location',
        identifier: 'location'
    },
    {
        name: 'Website',
        identifier: 'url'
    }
];

const SUPPORTED_SOCIALS = [
    {
        name: 'Twitter',
        identifier: 'com.twitter',
        link (handle) {
            if (handle.includes('twitter.com/')) {
                return handle;
            }
            handle = handle.replace('@', '');
            return `https://twitter.com/${handle}`;
        }
    },
    {
        name: 'Facebook',
        identifier: 'com.facebook',
        link (handle) {
            if (handle.includes('facebook.com/')) {
                return handle;
            }
            return `https://facebook.com/${handle}`;
        }
    },
    {
        name: 'Instagram',
        identifier: 'com.instagram',
        link (handle) {
            if (handle.includes('instagram.com/')) {
                return handle;
            }
            return `https://instagram.com/${handle}`;
        }
    },
    {
        name: 'Reddit',
        identifier: 'com.reddit',
        link (handle) {
            if (handle.includes('reddit.com/')) {
                return handle;
            }
            return `https://reddit.com/${handle}`;
        }
    },
    {
        name: 'X',
        identifier: 'com.x',
        link (handle) {
            if (handle.includes('x.com/')) {
                return handle;
            }
            handle = handle.replace('@', '');
            return `https://x.com/${handle}`;
        }
    },
    {
        name: 'Github',
        identifier: 'com.github',
        link (handle) {
            if (handle.includes('github.com/')) {
                return handle;
            }
            return `https://github.com/${handle}`;
        }
    },
    {
        name: 'Email',
        identifier: 'email',
        link: (handle)=>`mailto:${handle}`
    },
    {
        name: 'Telegram',
        identifier: 'org.telegram',
        link: (handle)=>{
            if (handle.includes('t.me/')) {
                return handle;
            }
            return `https://t.me/${handle}`;
        }
    },
    {
        name: 'Discord',
        identifier: 'com.discord',
        link: (handle)=>{
            if (handle.includes('discord.gg/')) {
                return handle;
            }
            return `https://discord.gg/${handle}`;
        }
    }
];

const generalKeys = [
    'avatar',
    'banner',
    'header',
    'display',
    'description',
    'url',
    'location'
];
const createAddresses = (coins)=>{
    return coins.map((coin)=>{
        return _extends({}, coin, getCoinTypeDetails(coin.id.toString()));
    });
};
const createSocialsAndOthers = (texts)=>{
    return texts.reduce((acc, text)=>{
        const social = SUPPORTED_SOCIALS.find((social)=>social.identifier === text.key);
        if (social) {
            acc[0].push(_extends({}, text, {
                name: social.name
            }));
        } else {
            if (generalKeys.includes(text.key)) return acc;
            acc[1].push(text);
        }
        return acc;
    }, [
        [],
        []
    ]);
};
const createGenerals = (texts)=>{
    return texts.filter((text)=>generalKeys.includes(text.key)).map((text)=>{
        return _extends({}, text);
    });
};
const sanitizeRecords = (subnameResponse)=>{
    var _records_texts_find, _records_texts_find1, _records_texts_find2, _records_texts_find3, _records_texts_find4, _records_texts_find5, _records_texts_find6;
    if (!subnameResponse) {
        const ethAddress = _extends({
            id: 60,
            name: 'ETH',
            value: ''
        }, getCoinTypeDetails('60'));
        return {
            display: '',
            email: '',
            description: '',
            ethAddress,
            generals: [],
            allAddresses: [
                ethAddress
            ],
            otherAddresses: [],
            socials: [],
            allTexts: [],
            allOtherTexts: [],
            otherTextsWithoutStandard: [],
            contentHash: null,
            contentHashUri: null
        };
    }
    const { records } = subnameResponse;
    const contentHashUri = records.contentHash ? `${records.contentHash.protocolType}://${records.contentHash.decoded}` : null;
    if (!records) {
        const ethAddress = _extends({
            id: 60,
            name: 'ETH',
            value: ''
        }, getCoinTypeDetails('60'));
        return {
            display: '',
            email: '',
            description: '',
            ethAddress,
            generals: [],
            allAddresses: [
                ethAddress
            ],
            otherAddresses: [],
            socials: [],
            allOtherTexts: [],
            allTexts: [],
            otherTextsWithoutStandard: [],
            contentHash: null,
            contentHashUri: null
        };
    }
    const addresses = createAddresses(records.coins);
    const ethAddress = addresses.find((address)=>address.id === 60);
    if (!ethAddress) throw new Error('ETH address not found');
    if (!records.texts) return {
        ethAddress,
        generals: [],
        allAddresses: addresses,
        otherAddresses: addresses.filter((address)=>address.id !== 60),
        socials: [],
        allOtherTexts: [],
        allTexts: [],
        otherTextsWithoutStandard: [],
        contentHash: records.contentHash,
        contentHashUri
    };
    const [socials, allOtherTexts] = createSocialsAndOthers(records.texts);
    const generals = createGenerals(records.texts);
    const banner = (_records_texts_find = records.texts.find((text)=>text.key === 'banner')) == null ? void 0 : _records_texts_find.value;
    const header = (_records_texts_find1 = records.texts.find((text)=>text.key === 'header')) == null ? void 0 : _records_texts_find1.value;
    const avatar = (_records_texts_find2 = records.texts.find((text)=>text.key === 'avatar')) == null ? void 0 : _records_texts_find2.value;
    const display = (_records_texts_find3 = records.texts.find((text)=>text.key === 'display')) == null ? void 0 : _records_texts_find3.value;
    const email = (_records_texts_find4 = records.texts.find((text)=>text.key === 'email')) == null ? void 0 : _records_texts_find4.value;
    const description = (_records_texts_find5 = records.texts.find((text)=>text.key === 'description')) == null ? void 0 : _records_texts_find5.value;
    const url = (_records_texts_find6 = records.texts.find((text)=>text.key === 'url')) == null ? void 0 : _records_texts_find6.value;
    const otherTextsWithoutStandard = allOtherTexts.filter((other)=>!generalKeys.includes(other.key));
    return {
        avatar,
        banner,
        header,
        display,
        email,
        description,
        ethAddress,
        generals,
        url,
        otherAddresses: addresses.filter((address)=>address.id !== 60),
        allAddresses: addresses,
        allTexts: records.texts,
        socials,
        allOtherTexts,
        otherTextsWithoutStandard,
        contentHash: records.contentHash,
        contentHashUri
    };
};

const sanitizeTexts = (texts)=>{
    if (!texts) return undefined;
    if (Array.isArray(texts)) {
        return texts;
    }
    return Object.entries(texts).map(([key, value])=>({
            key,
            value
        }));
};
const sanitizeAddresses = (addresses)=>{
    if (!addresses) return undefined;
    if (Array.isArray(addresses)) {
        return addresses.map(({ address, coinType })=>({
                address,
                coinType: parseInt(coinType)
            }));
    }
    return Object.entries(addresses).map(([coinType, address])=>({
            coinType: parseInt(coinType),
            address
        }));
};

class Subnames {
    async acceptSubname(params, headers) {
        var _this_ensDomains_find, _this_ensDomains;
        const { text, addresses, ensDomain, chainId, signature: paramSignature } = params, rest = _object_without_properties_loose(params, [
            "text",
            "addresses",
            "ensDomain",
            "chainId",
            "signature"
        ]);
        const { signature, xSignature } = this.checkSignature(paramSignature, headers.xSignature);
        const sanitizedAddresses = sanitizeAddresses(params.addresses);
        const hasAddress60 = sanitizedAddresses == null ? void 0 : sanitizedAddresses.some((address)=>address.coinType === 60);
        const _chainId = chainId || this.chainId;
        const _ensDomain = ensDomain || ((_this_ensDomains = this.ensDomains) == null ? void 0 : (_this_ensDomains_find = _this_ensDomains.find((ensDomain)=>ensDomain.chainId === _chainId)) == null ? void 0 : _this_ensDomains_find.ensDomain);
        return assertRestCall('ACCEPT_SUBNAME_ROUTE', 'POST', _extends({
            chainId: _chainId,
            ensDomain: _ensDomain,
            text: sanitizeTexts(params.text),
            addresses: hasAddress60 ? sanitizedAddresses : [
                {
                    coinType: 60,
                    address: headers.xAddress
                },
                ...sanitizedAddresses === undefined ? [] : sanitizedAddresses
            ]
        }, rest, {
            signature
        }), _extends({}, headers, {
            xSignature
        }), this.dev)([
            'username',
            'ensDomain',
            'chainId'
        ], [
            'xMessage',
            'xAddress'
        ]);
    }
    async reserveSubname(params) {
        var _this_ensDomains_find, _this_ensDomains, _this_ensDomains_find1, _this_ensDomains1;
        const { ensDomain, chainId, apiKey } = params, rest = _object_without_properties_loose(params, [
            "ensDomain",
            "chainId",
            "apiKey"
        ]);
        const _apiKey = ((_this_ensDomains = this.ensDomains) == null ? void 0 : (_this_ensDomains_find = _this_ensDomains.find((ensDomain)=>ensDomain.chainId === chainId)) == null ? void 0 : _this_ensDomains_find.apiKey) || apiKey;
        const _chainId = chainId || this.chainId;
        const _ensDomain = ensDomain || ((_this_ensDomains1 = this.ensDomains) == null ? void 0 : (_this_ensDomains_find1 = _this_ensDomains1.find((ensDomain)=>ensDomain.chainId === _chainId)) == null ? void 0 : _this_ensDomains_find1.ensDomain);
        return assertRestCall('RESERVE_SUBNAME_ROUTE', 'POST', _extends({
            chainId: _chainId,
            ensDomain: _ensDomain
        }, rest), {
            xApiKey: _apiKey
        }, this.dev)([
            'ensDomain',
            'chainId',
            'ethAddress',
            'username'
        ], [
            'xApiKey'
        ]);
    }
    async addSubname(params, headers) {
        var _this_ensDomains_find, _this_ensDomains, _this_ensDomains_find1, _this_ensDomains1;
        const { text, addresses, ensDomain, chainId, apiKey, signature: paramSignature } = params, rest = _object_without_properties_loose(params, [
            "text",
            "addresses",
            "ensDomain",
            "chainId",
            "apiKey",
            "signature"
        ]);
        const { signature, xSignature } = this.checkSignature(paramSignature, headers == null ? void 0 : headers.xSignature, rest.overrideSignatureCheck);
        const sanitizedAddresses = sanitizeAddresses(params.addresses);
        const hasAddress60 = sanitizedAddresses == null ? void 0 : sanitizedAddresses.some((address)=>address.coinType === 60);
        const _chainId = chainId || this.chainId;
        const _ensDomain = ensDomain || ((_this_ensDomains = this.ensDomains) == null ? void 0 : (_this_ensDomains_find = _this_ensDomains.find((ensDomain)=>ensDomain.chainId === _chainId)) == null ? void 0 : _this_ensDomains_find.ensDomain);
        const _apiKey = (headers == null ? void 0 : headers.xApiKey) || ((_this_ensDomains1 = this.ensDomains) == null ? void 0 : (_this_ensDomains_find1 = _this_ensDomains1.find((ensDomain)=>ensDomain.chainId === _chainId)) == null ? void 0 : _this_ensDomains_find1.apiKey) || apiKey;
        const requiredHeaders = [
            "xApiKey"
        ];
        if (!rest.overrideSignatureCheck) {
            requiredHeaders.push("xAddress", "xMessage");
        }
        return assertRestCall('ADD_SUBNAME_ROUTE', 'POST', _extends({
            chainId: _chainId,
            ensDomain: _ensDomain,
            text: sanitizeTexts(params.text),
            addresses: hasAddress60 ? sanitizedAddresses : [
                {
                    coinType: 60,
                    address: headers == null ? void 0 : headers.xAddress
                },
                ...sanitizedAddresses === undefined ? [] : sanitizedAddresses
            ]
        }, rest, {
            signature
        }), _extends({}, headers, {
            xSignature,
            xApiKey: _apiKey
        }), this.dev)([
            'username',
            'ensDomain',
            'chainId'
        ], requiredHeaders);
    }
    async updateSubname(params, headers) {
        var _this_ensDomains_find, _this_ensDomains;
        const { text, addresses, ensDomain, chainId, signature: paramSignature } = params, rest = _object_without_properties_loose(params, [
            "text",
            "addresses",
            "ensDomain",
            "chainId",
            "signature"
        ]);
        const { signature, xSignature } = this.checkSignature(paramSignature, headers.xSignature);
        const _chainId = chainId || this.chainId;
        const _ensDomain = ensDomain || ((_this_ensDomains = this.ensDomains) == null ? void 0 : (_this_ensDomains_find = _this_ensDomains.find((ensDomain)=>ensDomain.chainId === _chainId)) == null ? void 0 : _this_ensDomains_find.ensDomain);
        return assertRestCall('UPDATE_SUBNAME_ROUTE', 'POST', _extends({
            chainId: _chainId,
            ensDomain: _ensDomain,
            text: sanitizeTexts(params.text),
            addresses: sanitizeAddresses(params.addresses)
        }, rest, {
            signature
        }), _extends({}, headers, {
            xSignature
        }), this.dev)([
            'username',
            'ensDomain',
            'chainId'
        ], [
            'xMessage',
            'xAddress'
        ]);
    }
    async revokeSubname(params, headers) {
        var _this_ensDomains_find, _this_ensDomains, _this_ensDomains_find1, _this_ensDomains1;
        const { ensDomain, chainId, apiKey, signature: paramSignature } = params, rest = _object_without_properties_loose(params, [
            "ensDomain",
            "chainId",
            "apiKey",
            "signature"
        ]);
        const { signature, xSignature } = this.checkSignature(paramSignature, headers.xSignature);
        const _chainId = chainId || this.chainId;
        const _ensDomain = ensDomain || ((_this_ensDomains = this.ensDomains) == null ? void 0 : (_this_ensDomains_find = _this_ensDomains.find((ensDomain)=>ensDomain.chainId === _chainId)) == null ? void 0 : _this_ensDomains_find.ensDomain);
        const _apiKey = headers.xApiKey || ((_this_ensDomains1 = this.ensDomains) == null ? void 0 : (_this_ensDomains_find1 = _this_ensDomains1.find((ensDomain)=>ensDomain.chainId === _chainId)) == null ? void 0 : _this_ensDomains_find1.apiKey) || apiKey;
        return assertRestCall('REVOKE_SUBNAME_ROUTE', 'POST', _extends({
            chainId: _chainId,
            ensDomain: _ensDomain
        }, rest, {
            signature
        }), _extends({}, headers, {
            xApiKey: _apiKey,
            xSignature
        }), this.dev)([
            'username',
            'ensDomain',
            'chainId'
        ], [
            'xApiKey',
            'xAddress',
            'xMessage'
        ]);
    }
    async rejectSubname(params, headers) {
        var _this_ensDomains_find, _this_ensDomains;
        const { ensDomain, chainId, username, signature: paramSignature } = params;
        const { signature, xSignature } = this.checkSignature(paramSignature, headers.xSignature);
        const _chainId = chainId || this.chainId;
        const _ensDomain = ensDomain || ((_this_ensDomains = this.ensDomains) == null ? void 0 : (_this_ensDomains_find = _this_ensDomains.find((ensDomain)=>ensDomain.chainId === _chainId)) == null ? void 0 : _this_ensDomains_find.ensDomain);
        return assertRestCall('REJECT_SUBNAME_ROUTE', 'POST', {
            chainId: _chainId,
            ensDomain: _ensDomain,
            username,
            signature
        }, _extends({}, headers, {
            xSignature
        }), this.dev)([
            'username',
            'ensDomain',
            'chainId'
        ], [
            'xMessage',
            'xAddress'
        ]);
    }
    async getSubnamesByEnsDomainWithCount(params) {
        const { chainId } = params, rest = _object_without_properties_loose(params, [
            "chainId"
        ]);
        const _chainId = chainId || this.chainId;
        return assertRestCall('GET_ALL_ENS_WITH_COUNT_ROUTE', 'GET', _extends({
            chainId: _chainId
        }, rest), undefined, this.dev)([
            'chainId'
        ]);
    }
    async getSubname(params) {
        const { chainId } = params, rest = _object_without_properties_loose(params, [
            "chainId"
        ]);
        const _chainId = chainId || this.chainId;
        return assertRestCall('GET_SUBNAME_BY_SUBNAME_ROUTE', 'GET', _extends({
            chainId: _chainId
        }, rest), undefined, this.dev)([
            'chainId'
        ]);
    }
    async getSubnamesByAddress(params) {
        const { chainId, isClaimed, coinType } = params, rest = _object_without_properties_loose(params, [
            "chainId",
            "isClaimed",
            "coinType"
        ]);
        const _chainId = chainId || this.chainId;
        return assertRestCall('GET_ALL_SUBNAMES_BY_ADDRESS_ROUTE', 'GET', _extends({
            chainId: _chainId,
            isClaimed: isClaimed,
            coinType: coinType
        }, rest), undefined, this.dev)([
            'chainId'
        ]);
    }
    async getInvitationsByAddress(params) {
        const { chainId, coinType } = params, rest = _object_without_properties_loose(params, [
            "chainId",
            "coinType"
        ]);
        const _chainId = chainId || this.chainId;
        return assertRestCall('GET_ALL_SUBNAMES_BY_INVITATION_ROUTE', 'GET', _extends({
            chainId: _chainId,
            coinType: coinType || 60,
            isClaimed: false
        }, rest), undefined, this.dev)([
            'chainId'
        ]);
    }
    async getSubnamesByEnsDomain(params) {
        var _this_ensDomains_find, _this_ensDomains;
        const { chainId, ensDomain } = params, rest = _object_without_properties_loose(params, [
            "chainId",
            "ensDomain"
        ]);
        const _chainId = chainId || this.chainId;
        const _ensDomain = ensDomain || ((_this_ensDomains = this.ensDomains) == null ? void 0 : (_this_ensDomains_find = _this_ensDomains.find((ensDomain)=>ensDomain.chainId === _chainId)) == null ? void 0 : _this_ensDomains_find.ensDomain);
        return assertRestCall('GET_ALL_SUBNAMES_BY_DOMAIN_ROUTE', 'GET', _extends({
            chainId: _chainId,
            ensDomain: _ensDomain
        }, rest), undefined, this.dev)([
            'ensDomain',
            'chainId'
        ]);
    }
    async searchSubnames(params) {
        const { chainId } = params, rest = _object_without_properties_loose(params, [
            "chainId"
        ]);
        const _chainId = chainId || this.chainId;
        return assertRestCall('SEARCH_SUBNAMES_ROUTE', 'GET', _extends({
            chainId: _chainId
        }, rest), undefined, this.dev)([
            'chainId'
        ]);
    }
    async isSubnameAvailable(params) {
        const { chainId } = params, rest = _object_without_properties_loose(params, [
            "chainId"
        ]);
        const _chainId = chainId || this.chainId;
        return assertRestCall('CHECK_SUBNAME_AVAILABILITY_ROUTE', 'GET', _extends({
            chainId: _chainId
        }, rest), undefined, this.dev)([
            'chainId'
        ]);
    }
    async getRecords(params) {
        var _this_networks_find;
        const { chainId } = params, rest = _object_without_properties_loose(params, [
            "chainId"
        ]);
        const _chainId = chainId || this.chainId;
        const providerUrl = (_this_networks_find = this.networks.find((network)=>network.chainId === _chainId)) == null ? void 0 : _this_networks_find.providerUrl;
        return assertRestCall('RECORDS_BY_FULLNAME_ROUTE', 'GET', _extends({
            providerUrl
        }, rest), undefined, this.dev)([
            'providerUrl'
        ]);
    }
    async setPrimaryName(params, headers) {
        const { chainId, signature: paramSignature } = params, rest = _object_without_properties_loose(params, [
            "chainId",
            "signature"
        ]);
        const _chainId = chainId || this.chainId;
        const { signature, xSignature } = this.checkSignature(paramSignature, headers.xSignature);
        return assertRestCall('SET_PRIMARY_NAME_ROUTE', 'POST', _extends({
            chainId: _chainId,
            signature
        }, rest), _extends({}, headers, {
            xSignature
        }), this.dev)([
            'chainId'
        ], [
            'xMessage',
            'xAddress'
        ]);
    }
    async getPrimaryNameByAddress(params) {
        const { chainId, address } = params;
        const _chainId = chainId || this.chainId;
        return assertRestCall('GET_PRIMARY_NAME_BY_ADDRESS_ROUTE', 'GET', {
            address,
            chainId: _chainId
        }, undefined, this.dev)([
            'chainId'
        ]);
    }
    checkSignature(params, headers, skipThrowError = false) {
        const signature = params || headers;
        if (!signature) {
            if (skipThrowError) {
                return {
                    signature: undefined,
                    xSignature: undefined
                };
            }
            throw InvalidConfigurationException.missingParameterOrHeader('signature');
        }
        if (signature.length > 15000) {
            return {
                signature,
                xSignature: undefined
            };
        }
        return {
            signature: undefined,
            xSignature: signature
        };
    }
    constructor(params){
        this.networks = params.networks;
        this.ensDomains = params.ensDomains;
        this.chainId = params.chainId;
        this.dev = params.dev;
    }
}

class OffchainResolvers {
    async getAllOffchainResolvers() {
        return restCall('GET_ALL_OFFCHAIN_RESOLVERS_ROUTE', 'GET', {}, {}, this.dev);
    }
    constructor(params){
        this.dev = params.dev || false;
    }
}

class SignIn {
    requestSignIn(params) {
        var _this_siweConfig, _this_siweConfig1;
        const chainId = params.chainId || this.chainId;
        const network = this.networks.find((network)=>network.chainId === chainId);
        if (!network) {
            throw new Error(`ChainId ${chainId} not supported`);
        }
        const uri = params.origin || ((_this_siweConfig = this.siweConfig) == null ? void 0 : _this_siweConfig.origin);
        const domain = params.domain || ((_this_siweConfig1 = this.siweConfig) == null ? void 0 : _this_siweConfig1.domain);
        const ttl = params.ttl || this.signInTtl || 60000;
        const missingParams = [];
        if (!uri) {
            missingParams.push('origin');
        }
        if (!domain) {
            missingParams.push('domain');
        }
        if (missingParams.length > 0) {
            throw InvalidConfigurationException.missingParameters(missingParams);
        }
        const siwens = new SIWENS({
            params: _extends({}, params, {
                uri,
                domain,
                chainId: chainId,
                ttl: ttl
            }),
            providerUrl: network.providerUrl
        });
        return siwens.prepareMessage();
    }
    async signIn(params) {
        const chainIdMatch = params.message.match(/Chain ID: (\d+)/);
        const extractChainId = chainIdMatch ? chainIdMatch[1] : null;
        if (!extractChainId) {
            throw new Error('Chain ID not found in message');
        }
        const extractedChainId = parseInt(extractChainId);
        if (isNaN(extractedChainId)) {
            throw new Error('Chain ID is not a number');
        }
        if (extractedChainId !== 1 && extractedChainId !== 11155111) {
            throw InvalidSignInException.chainIdNotSupported(extractedChainId.toString());
        }
        const chainId = extractedChainId;
        const network = this.networks.find((network)=>network.chainId === chainId);
        if (!network) {
            throw InvalidSignInException.chainIdNotSupported(chainId.toString());
        }
        const siwens = new SIWENS({
            params: params.message,
            providerUrl: network.providerUrl
        });
        const siwensResponse = await siwens.verify({
            signature: params.signature,
            nonce: params.nonce,
            domain: params.domain
        }, {
            provider: network.provider,
            verificationFallback: async (params, opts, message, EIP1271Promise)=>{
                const publicClient = createPublicClient({
                    chain: this.chainId === 1 ? mainnet : sepolia,
                    transport: http(network.providerUrl)
                });
                const result = await EIP1271Promise;
                if (result.success) {
                    return result;
                } else {
                    let signature = params.signature;
                    const lastByte = parseInt(params.signature.slice(-2), 16);
                    if (lastByte < 27) {
                        const adjustedV = (27 + lastByte % 2).toString(16).padStart(2, '0');
                        signature = signature.slice(0, -2) + adjustedV;
                    }
                    const viemResponse = await publicClient.verifySiweMessage({
                        message: message.toMessage(),
                        signature: signature,
                        address: result.data.address,
                        nonce: params.nonce,
                        domain: params.domain,
                        time: params.time ? new Date(params.time) : undefined,
                        scheme: params.scheme
                    });
                    if (viemResponse) {
                        return {
                            data: result.data,
                            success: true
                        };
                    }
                    return result;
                }
            }
        });
        if (siwensResponse.data.chainId !== chainId) {
            throw InvalidSignInException.chainIdMismatch(chainId.toString(), siwensResponse.data.chainId.toString());
        }
        if (params.domain) {
            if (siwensResponse.data.domain !== params.domain) {
                throw InvalidSignInException.domainMismatch(params == null ? void 0 : params.domain, siwensResponse.data.domain);
            }
        }
        if (params.nonce) {
            if (siwensResponse.data.nonce !== params.nonce) {
                throw InvalidSignInException.nonceMismatch(params == null ? void 0 : params.nonce, siwensResponse.data.nonce);
            }
        }
        const isJustaName = await this.checkIfJustaNameResolver(siwensResponse.ens, chainId);
        return _extends({}, siwensResponse, {
            isJustaName
        });
    }
    generateNonce() {
        return SIWENS.generateNonce();
    }
    async checkIfJustaNameResolver(ens, chainId) {
        const network = this.networks.find((network)=>network.chainId === chainId);
        if (!network) {
            throw new Error(`ChainId ${chainId} not supported`);
        }
        const [resolverAddress, resolvers] = await Promise.all([
            network.provider.getResolver(ens),
            this.offchainResolvers.getAllOffchainResolvers()
        ]);
        const currentOffchainResolver = resolvers.offchainResolvers.find((resolver)=>resolver.chainId === chainId);
        if (!currentOffchainResolver) {
            throw InvalidENSException.chainNotSupported(chainId.toString());
        }
        if (!(resolverAddress == null ? void 0 : resolverAddress.address)) {
            throw InvalidENSException.notRegisteredENS(ens);
        }
        return currentOffchainResolver.resolverAddress === (resolverAddress == null ? void 0 : resolverAddress.address);
    }
    constructor(params){
        this.siweConfig = params.siweConfig;
        this.networks = params.networks;
        this.chainId = params.chainId;
        this.offchainResolvers = params.offchainResolvers;
        this.signInTtl = params.signInTtl;
    }
}

class MApps {
    async checkIfMAppIsEnabled(params) {
        const chainId = params.chainId || this.chainId;
        const network = this.networks.find((network)=>network.chainId === chainId);
        if (!network) {
            throw new Error('Network not found');
        }
        const mApp = params.mApp;
        const ens = params.ens;
        const records = await this.subnames.getRecords({
            ens,
            chainId,
            providerUrl: network.providerUrl
        });
        if (!records) {
            return false;
        }
        if (!records.isJAN) {
            return false;
        }
        const mAppField = records.records.texts.find((text)=>text.key === 'mApps');
        if (!mAppField) {
            return false;
        }
        const mAppFieldValue = JSON.parse(mAppField.value);
        if (!mAppFieldValue) {
            return false;
        }
        return mAppFieldValue.mApps.includes(mApp);
    }
    async canEnableMApps(params) {
        const chainId = params.chainId || this.chainId;
        const ens = params.ens;
        const records = await this.subnames.getRecords({
            ens,
            chainId
        });
        return records.isJAN;
    }
    requestAddMAppPermissionChallenge(params) {
        var _this_siweConfig, _this_siweConfig1;
        const { chainId, ttl, origin, domain } = params, rest = _object_without_properties_loose(params, [
            "chainId",
            "ttl",
            "origin",
            "domain"
        ]);
        const _chainId = chainId || this.chainId;
        const _ttl = ttl || 120000;
        const _origin = origin || ((_this_siweConfig = this.siweConfig) == null ? void 0 : _this_siweConfig.origin);
        const _domain = domain || ((_this_siweConfig1 = this.siweConfig) == null ? void 0 : _this_siweConfig1.domain);
        return assertRestCall('SIWE_MAPP_ADD_PERMISSION_ROUTE', 'POST', _extends({
            ttl: _ttl,
            chainId: _chainId,
            origin: _origin,
            domain: _domain
        }, rest), undefined, this.dev)([
            'ttl',
            'chainId',
            'origin',
            'domain'
        ]);
    }
    requestAppendMAppFieldChallenge(params) {
        var _this_siweConfig, _this_siweConfig1;
        const { chainId, ttl, origin, domain } = params, rest = _object_without_properties_loose(params, [
            "chainId",
            "ttl",
            "origin",
            "domain"
        ]);
        const _chainId = chainId || this.chainId;
        const _ttl = ttl || 120000;
        const _origin = origin || ((_this_siweConfig = this.siweConfig) == null ? void 0 : _this_siweConfig.origin);
        const _domain = domain || ((_this_siweConfig1 = this.siweConfig) == null ? void 0 : _this_siweConfig1.domain);
        return assertRestCall('SIWE_MAPP_APPEND_FIELD_ROUTE', 'POST', _extends({
            ttl: _ttl,
            chainId: _chainId,
            origin: _origin,
            domain: _domain
        }, rest), undefined, this.dev)([
            'ttl',
            'chainId',
            'origin',
            'domain'
        ]);
    }
    requestRevokeMAppPermissionChallenge(params) {
        var _this_siweConfig, _this_siweConfig1;
        const { chainId, ttl, origin, domain } = params, rest = _object_without_properties_loose(params, [
            "chainId",
            "ttl",
            "origin",
            "domain"
        ]);
        const _chainId = chainId || this.chainId;
        const _ttl = ttl || 120000;
        const _origin = origin || ((_this_siweConfig = this.siweConfig) == null ? void 0 : _this_siweConfig.origin);
        const _domain = domain || ((_this_siweConfig1 = this.siweConfig) == null ? void 0 : _this_siweConfig1.domain);
        return assertRestCall('SIWE_MAPP_REVOKE_PERMISSION_ROUTE', 'POST', _extends({
            ttl: _ttl,
            chainId: _chainId,
            origin: _origin,
            domain: _domain
        }, rest), undefined, this.dev)([
            'ttl',
            'chainId',
            'origin',
            'domain'
        ]);
    }
    addMAppPermission(params) {
        return assertRestCall('MAPP_ADD_PERMISSION_ROUTE', 'POST', _extends({}, params), undefined, this.dev)([
            'message',
            'address',
            'signature'
        ]);
    }
    appendMAppField(params, headers) {
        return assertRestCall('MAPP_APPEND_FIELD_ROUTE', 'POST', _extends({}, params), _extends({}, headers), this.dev)([
            'subname',
            'fields'
        ], [
            'xAddress',
            'xMessage',
            'xSignature'
        ]);
    }
    revokeMAppPermission(params) {
        return assertRestCall('MAPP_REVOKE_PERMISSION_ROUTE', 'POST', _extends({}, params), undefined, this.dev)([
            'message',
            'address',
            'signature'
        ]);
    }
    constructor(params){
        this.siweConfig = params.siweConfig;
        this.chainId = params.chainId;
        this.subnames = params.subnames;
        this.networks = params.networks;
        this.dev = params.dev;
    }
}

// inspired by spruceid siwe: https://github.com/spruceid/siwe/blob/main/packages/siwe/lib/ethersCompat.ts
const ethersCompat = ethers;
const getJsonRpcProvider = (providerUrl, chainId)=>{
    if ('JsonRpcProvider' in ethersCompat) {
        return new ethersCompat.JsonRpcProvider(providerUrl, chainId);
    } else {
        return new ethersCompat.providers.JsonRpcProvider(providerUrl, chainId);
    }
};
'namehash' in ethersCompat ? ethersCompat.namehash : ethersCompat.utils.namehash;
'getAddress' in ethersCompat ? ethersCompat.getAddress : ethersCompat.utils.getAddress;

/**
 * The main class for the JustaName SDK.
 * @public
 * @class
 * @classdesc The main class for the JustaName SDK.
 * @example
 * ```typescript
 * import { JustaName } from '@justaname.id/sdk';
 *
 * const configuration = {
 *  apiKey: 'your-api-key',
 *  networks: [
 *  {
 *  chainId: 1,
 *  providerUrl: 'https://mainnet.infura.io/v3/your-infura-key'
 *  },
 *  ],
 *  ensDomains: ['justan.id']
 *  };
 *
 *  const justaName = JustaName.init(configuration);
 *
 *  ```
 */ class JustaName {
    static init(configuration = {}) {
        var _configuration_networks_, _configuration_config;
        const dev = configuration.dev || false;
        const defaultChainId = configuration.defaultChainId || configuration && (configuration == null ? void 0 : configuration.networks) && ((_configuration_networks_ = configuration.networks[0]) == null ? void 0 : _configuration_networks_.chainId) || 1;
        const networks = JustaName.createNetworks(configuration.networks);
        const ensDomains = configuration.ensDomains || [];
        const sanitizedConfiguration = _extends({}, configuration, {
            defaultChainId,
            networks,
            ensDomains
        });
        this.checkConfig(sanitizedConfiguration);
        const siweConfig = configuration.config && configuration.config.domain && configuration.config.origin ? {
            domain: configuration.config.domain,
            origin: configuration.config.origin
        } : undefined;
        const subnameChallenge = new SubnameChallenge({
            siweConfig,
            chainId: defaultChainId,
            subnameChallengeTtl: (_configuration_config = configuration.config) == null ? void 0 : _configuration_config.subnameChallengeTtl,
            dev
        });
        const subnames = new Subnames({
            networks,
            chainId: defaultChainId,
            ensDomains,
            dev
        });
        const offchainResolvers = new OffchainResolvers({
            dev
        });
        const signIn = new SignIn({
            siweConfig,
            networks,
            chainId: defaultChainId,
            offchainResolvers
        });
        const mApps = new MApps({
            siweConfig,
            chainId: defaultChainId,
            networks,
            subnames,
            dev
        });
        return new JustaName(subnameChallenge, subnames, offchainResolvers, signIn, mApps);
    }
    static createNetworks(networks = []) {
        const defaultMainnetProviderUrl = 'https://cloudflare-eth.com';
        const defaultTestnetProviderUrl = 'https://rpc.sepolia.org';
        const defaultMainnetProvider = getJsonRpcProvider(defaultMainnetProviderUrl, 1);
        const defaultTestnetProvider = getJsonRpcProvider(defaultTestnetProviderUrl, 11155111);
        const baseNetworks = [
            {
                chainId: 1,
                provider: defaultMainnetProvider,
                providerUrl: defaultMainnetProviderUrl
            },
            {
                chainId: 11155111,
                provider: defaultTestnetProvider,
                providerUrl: defaultTestnetProviderUrl
            }
        ];
        const baseNetworksConfig = baseNetworks.map((_network)=>{
            const network = networks.find((n)=>n.chainId === _network.chainId);
            if (network && (network == null ? void 0 : network.providerUrl)) {
                return {
                    chainId: network.chainId,
                    provider: getJsonRpcProvider(network.providerUrl),
                    providerUrl: network.providerUrl
                };
            } else {
                return _network;
            }
        });
        const mainnetNetwork = baseNetworksConfig.find((n)=>n.chainId === 1);
        const testnetNetwork = baseNetworksConfig.find((n)=>n.chainId === 11155111);
        // const localNetwork = baseNetworksConfig.find(
        //   (n) => n.chainId === 31337
        // ) as NetworkWithProvider<31337>;
        if (!mainnetNetwork) {
            throw new InvalidConfigurationException('The mainnet network is missing');
        }
        if (!testnetNetwork) {
            throw new InvalidConfigurationException('The testnet network is missing');
        }
        return [
            mainnetNetwork,
            testnetNetwork
        ];
    }
    static checkConfig(configuration) {
    // To be optimized for serverless and re added later
    // this.checkNetworks(configuration.networks);
    }
    constructor(siwe, subnames, offchainResolvers, signIn, mApps){
        this.siwe = siwe;
        this.subnames = subnames;
        this.offchainResolvers = offchainResolvers;
        this.signIn = signIn;
        this.mApps = mApps;
    }
}

export { ApiKeyRequiredException, GENERAL_FIELDS, InvalidConfigurationException, InvalidENSException, InvalidSignInException, JustaName, MApps, OffchainResolvers, Routes, SUPPORTED_SOCIALS, SignIn, SubnameChallenge, Subnames, coinTypeMap, createAddresses, createGenerals, createSocialsAndOthers, generalKeys, getCoinTypeDetails, sanitizeAddresses, sanitizeRecords, sanitizeTexts };
